import { Autocomplete, AutocompleteProps } from '@mui/material'
import React, { useRef } from 'react'

type OffsetValue = number | string

interface MobileViewAutocompleteProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  headerOffset?: OffsetValue
}

export const MobileViewAutocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: MobileViewAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
) => {
  const { onOpen, renderInput, headerOffset = 0, ...rest } = props
  const containerRef = useRef<HTMLDivElement>(null)

  const parseOffset = (offset: OffsetValue): number => {
    if (typeof offset === 'string') {
      return parseInt(offset.replace('px', '').trim(), 10) || 0
    }
    return offset
  }

  const handleOpen = (event: React.SyntheticEvent) => {
    if (onOpen) onOpen(event)
    setTimeout(() => {
      const element = containerRef.current
      if (element) {
        const offset = parseOffset(headerOffset)
        const topPosition = element.getBoundingClientRect().top + window.scrollY
        window.scrollTo({
          top: topPosition - offset,
          behavior: 'smooth',
        })
      }
    }, 300)
  }

  return (
    <div ref={containerRef}>
      <Autocomplete
        {...rest}
        onOpen={handleOpen}
        renderInput={params => renderInput(params)}
        ListboxProps={{
          sx: {
            maxHeight: 200,
            overflow: 'auto',
          },
        }}
        slotProps={{
          paper: {
            sx: {
              maxHeight: 'none',
            },
          },
        }}
      />
    </div>
  )
}
